import { useTheme } from "@/components/theme-provider";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

interface SlikeLogoProps {
    className?: string;
    iconClassName?: string;
    textClassName?: string;
}

const getResolvedTheme = (theme: "dark" | "light" | "system"): "light" | "dark" => {
    if (theme === "system") {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    return theme;
};

export function SlikeLogo({ className, iconClassName, textClassName }: SlikeLogoProps) {
    const { theme } = useTheme();
    const [resolvedTheme, setResolvedTheme] = useState<"light" | "dark">(() => getResolvedTheme(theme));

    useEffect(() => {
        if (theme === "system") {
            const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
            setResolvedTheme(systemTheme);

            const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
            const handler = (e: MediaQueryListEvent) => setResolvedTheme(e.matches ? "dark" : "light");
            mediaQuery.addEventListener("change", handler);
            return () => mediaQuery.removeEventListener("change", handler);
        } else {
            setResolvedTheme(theme);
        }
    }, [theme]);

    return (
        <div className={cn("flex items-center gap-1", className)}>
            <img
                src={resolvedTheme === "dark" ? "/slikelogo-light.svg" : "/slikelogo.svg"}
                alt="Slike"
                className={cn("h-7", iconClassName)}
                onError={(e) => {
                    if (resolvedTheme === "dark") {
                        const target = e.target as HTMLImageElement;
                        if (target.src !== "/slikelogo.svg") {
                            target.src = "/slikelogo.svg";
                        }
                    }
                }}
                loading="lazy"
            />
            {/* <span className={cn(
                "text-2xl font-bold  text-foreground/80",
                textClassName
            )} style={{
                fontFamily: "Fjalla One", fontWeight: "700", fontStyle: "italic",
                fontOpticalSizing: "auto", letterSpacing: "0.05em"
            }} >
                Slike
            </span> */}
        </div>
    );
}
